export default {
  headingSizes: { 1: 64, 2: 36, 3: 24 },
  bodySizes: { lead: 24, base: 18, small: 14 },
}
